document.addEventListener("DOMContentLoaded", () => {
    if (window.TNCMS.User?.isLoggedIn()) {
        document.querySelectorAll('.follow-modal .logged-in').forEach(el => el.hidden = false);
    } else {
        document.querySelectorAll('.follow-modal .logged-out').forEach(el => el.hidden = false);
    }

    document.addEventListener('submit', function (e) {
        e.preventDefault();
        const form = e.target.closest('.follow-modal form');
        const modal = e.target.closest('.follow-modal');

        if (!form) return; // Ignore forms not inside a .follow-modal

        var params = new URLSearchParams();
        params.append('title', form.title.value);

        fetch(form.action, {
            method: 'POST',
            body: params.toString()
        })
            .then(response => {
                if (response.ok) {
                    displaySuccess();
                } else {
                    displayFail();
                }
            })
            .catch(() => {
                displayFail();
            });

        function displaySuccess() {
            modal.querySelector('.follow-button').disable();
            modal.querySelector('.system-error').style.display = 'none';
            modal.querySelector('.follow-button .button-text').innerText = 'Following';
            modal.querySelector('.follow-button .icon-container').classList.toggle('checked');
        }

        function displayFail() {
            modal.querySelector('.follow-button').enable();
            modal.querySelector('.system-error').style.display = 'block';
        }
    });
});